<template>
    <v-card elevation="1">
        <v-card-title>Mobility</v-card-title>

        <v-alert v-if="showEliteMobilityNotice" border="left" class="mx-4" colored-border type="info">
            This meet is not an elite mobility meet. The scores shown are simply for informational purposes.
        </v-alert>

        <v-tabs v-if="mobilities.length > 1" v-model="mobilityTab">
            <v-tab v-for="mobility in mobilities" :key="mobility.id">
                {{ mobility.level_to }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-if="mobilities.length > 1" v-model="mobilityTab">
            <v-tab-item v-for="mobility in mobilities" :key="mobility.id">
                <mobility-table :mobility="mobility" />
            </v-tab-item>
        </v-tabs-items>

        <div v-else>
            <mobility-table v-for="mobility in mobilities" :key="mobility.id" :mobility="mobility" />
        </div>
    </v-card>
</template>

<script>
import MobilityTable from '@/Components/MobilityTable.vue';
import Meet from '@/Models/Meet.js';

export default {
    name: 'MobilityDisplay',

    components: { MobilityTable },

    props: {
        value: {
            type: Boolean,
            required: false,
            default: false,
        },

        mobilities: {
            type: Array,
            required: true,
        },

        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        mobilityTab: 0,
    }),

    computed: {
        showEliteMobilityNotice() {
            if (this.meet.elite_mobility) {
                return false;
            }

            return this.mobilities.filter(mobility => mobility.is_elite_mobility).length > 0;
        },
    },

    methods: {},
};
</script>
